import { Empty } from 'antd';
import React from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import MachineConf from './MachineConf';

export default function Machine() {
    const { _id } = useParams();
    const Machine = useSelector(state => state.machines.data).filter(cl=>cl._id===_id)
   //console.log(Machine)
    return (
        <>
        {
           Machine.length === 0 ? <Empty /> :<MachineConf item={Machine[0]}></MachineConf>
        }            
        </>
    )
}
 